import * as React from 'react';

import { INewbuildingBuilderSchema } from '../../repositories/newbuilding-card/entities/builder/NewbuildingBuilderSchema';
import { INewbuildingSellerSchema } from '../../repositories/newbuilding-card/entities/agents/NewbuildingSellerSchema';
import { Sellers } from './parts/Sellers';
import { Builders } from './parts/Builders';
import { LayoutBlock } from '../LayoutBlock';
import { Section } from '../Section';

export interface IBuildersInfoProps {
  newbuildingId: number;
  builders?: INewbuildingBuilderSchema[] | null;
  sellers?: INewbuildingSellerSchema[] | null;
  newbuildingDisplayName?: string;
  isLeadFactory?: boolean;
  trackActionOpenContactsCall(builder: INewbuildingBuilderSchema | INewbuildingSellerSchema): void;
}

export const BuildersInfo: React.FC<IBuildersInfoProps> = props => {
  const { builders, sellers, trackActionOpenContactsCall, newbuildingDisplayName, newbuildingId, isLeadFactory } =
    props;

  const isBuildersHere = builders && builders.length > 0;
  const isSellersHere = sellers && sellers.length > 0;

  if (!isBuildersHere && !isSellersHere) {
    return null;
  }

  return (
    <LayoutBlock>
      <Section id="developer" data-data-nav-tab="developer/Про застройщика" data-mark="BuildersInfo">
        <Builders builders={builders} newbuildingDisplayName={newbuildingDisplayName} />

        {!isLeadFactory && (
          <Sellers
            newbuildingId={newbuildingId}
            isPlural={builders && builders.length > 1}
            sellers={sellers}
            trackActionOpenContactsCall={trackActionOpenContactsCall}
          />
        )}
      </Section>
    </LayoutBlock>
  );
};
